/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { isValid } from 'src/services/auth';

import CustomInput, { ConsultaInput, SelectInput } from '.';

export function RenderForm({ data, onSubmit }) {
  const idEmp = localStorage.getItem('idEmp');
  const idFil = localStorage.getItem('idFil');

  const [form, setForm] = useState({});

  const formatData = (data) => {
    const [dataAno, dataMes, dataDia] = data.split('-');
    return `${dataDia}/${dataMes}/${dataAno}`;
  };

  useEffect(() => {
    const ignored = ['codemp', 'codfil', 'tipAca'];
    const entries = Object.entries(form).filter(
      ([key]) => !ignored.includes(key)
    );

    const allValid =
      entries.length > 0 && entries.every(([_, value]) => isValid(value));

    if (allValid) {
      onSubmit(form);
    }
  }, [form]);

  return (
    <>
      {Object.entries(data).map(([key, item]) => {
        if (typeof item === 'object') {
          let tipo = 'text';
          switch (item.tipo) {
            case 'integer':
            case 'float':
              tipo = 'number';
              break;
            case 'date':
              tipo = 'date';
              break;
            case 'webservice':
              tipo = 'consulta';
              break;
            case 'select':
              tipo = 'select';
              break;
            default:
              tipo = 'text';
              break;
          }

          if (
            key !== 'titulo' &&
            key !== 'endpoint' &&
            key !== 'relatorios' &&
            item.mostrar !== 'N'
          ) {
            let valor = item.valor || '';

            if (tipo === 'date' && valor) {
              const [day, month, year] = valor.split('/');
              valor = `${year}-${month}-${day}`;
            }

            if (key === 'codemp') {
              valor = idEmp;

              if (!isValid(form[key]))
                setForm((prev) => ({
                  ...prev,
                  [key]: idEmp,
                }));
            }

            if (key === 'codfil') {
              valor = idFil;

              if (!isValid(form[key]))
                setForm((prev) => ({
                  ...prev,
                  [key]: idFil,
                }));
            }

            return (
              <div
                key={key}
                className={`tamanho${item.tamanho}`}
                style={{ order: `${item.posicao}` }}
              >
                {tipo === 'text' || tipo === 'number' || tipo === 'date' ? (
                  <CustomInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(form[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''}`}
                    Type={tipo}
                    Disabled={item.editavel === 'N'}
                    OnChange={(e) => {
                      if (tipo === 'date') {
                        setForm((prev) => ({
                          ...prev,
                          [key]: formatData(e.target.value),
                        }));
                      } else {
                        setForm((prev) => ({
                          ...prev,
                          [key]: e.target.value,
                        }));
                      }
                    }}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    DefaultValue={valor}
                  />
                ) : tipo === 'consulta' ? (
                  <ConsultaInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(form[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''}`}
                    Type={tipo}
                    Disabled={item.editavel === 'N'}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    DefaultValue={valor}
                  />
                ) : (
                  <SelectInput
                    Class={
                      item.obrigatorio === 'S' && !isValid(form[key])
                        ? 'obr'
                        : ''
                    }
                    PlaceHolder={`${item.nome} ${item.obrigatorio === 'S' ? '*' : ''}`}
                    Type={tipo}
                    Disabled={item.editavel === 'N'}
                    Options={item.options}
                    CorFundo={item.corfundo}
                    CorTexto={item.cortexto}
                    DefaultValue={valor}
                    OnChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        [key]: e.target.value,
                      }))
                    }
                  />
                )}
              </div>
            );
          }
          return null;
        }
      })}

      <button className="mainButton turquoise" onClick={() => onSubmit(form)}>
        Consultar
      </button>
    </>
  );
}

RenderForm.propTypes = {
  data: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
